<template>
  <page :title="$tc('notification._name')">
    <div slot="page-header-right">
      <router-link class="button is-primary" to="/pns/compose">{{$tc('notification.send')}}</router-link>
      <router-link class="button is-danger" to="/pns/scheduled" style="margin-left:20px;">{{$tc('notification.scheduled')}}</router-link>
    </div>
    <div class="box">
      <b-table
        :data="notifications.data"
        :loading="notifications.loading"
        paginated
        backend-pagination
        pagination-position="bottom"
        :current-page="notifications.current_page"
        :per-page="notifications.per_page"
        :total="notifications.total"
        @page-change="page => notifications.changePage(page)"
      >
        <template slot-scope="props">

          <b-table-column :label="$tc('dater.date')">
            <span class="has-text-grey">{{ props.row.created_at | dateTime }}</span>
          </b-table-column>
          <b-table-column :label="$tc('support_ticket.title')">
            <div
              style="clear: both; display: inline-block; overflow: hidden; white-space: nowrap;max-width: 300px; text-overflow: ellipsis;"
            >{{ props.row.data.title }}</div>
          </b-table-column>

          <b-table-column :label="$tc('recipient')">
            <div
              class="has-text-grey"
              style="clear: both; display: inline-block; overflow: hidden; white-space: nowrap;max-width: 200px; text-overflow: ellipsis;"
            >{{ props.row.notifiable.name }}</div>
          </b-table-column>


        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"></b-icon>
              </p>
              <p>No result.</p>
            </div>
          </section>
        </template>
      </b-table>
    </div>
  </page>
</template>

<script>
export default {
  data() {
    return {
      notifications: new window.PaginatedRemoteCollection(
        "/admin/api/notifications"
      ).load()
    };
  }
};
</script>
